export default "__VITE_ASSET__CFkJ5TMP__"